import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

const EditWorkflowNameDialog = ({ open, onClose, name, description, onSave }) => {
  const [editName, setEditName] = useState(name || '');
  const [editDesc, setEditDesc] = useState(description || '');

  useEffect(() => {
    setEditName(name || '');
    setEditDesc(description || '');
  }, [name, description, open]);

  const handleSave = () => {
    onSave(editName, editDesc);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Change flow name?</DialogTitle>
      <DialogContent>
        <TextField
          label="Flow Name"
          value={editName}
          onChange={e => setEditName(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Flow Description"
          value={editDesc}
          onChange={e => setEditDesc(e.target.value)}
          fullWidth
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" sx={{ borderRadius: 5 }} onClick={handleSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditWorkflowNameDialog; 